module.exports = __webpack_public_path__ + "static/media/compress-lines.bf5c61dd.svg";